<template lang="pug">
  div( v-if="item" :class="{read : isRead, active : isActive}" class="leadContainer pa-0 my-2 ma-0 px-3 tw-rounded tw-border tw-border-gray-lighten-3" @click="click()" )
    v-container( class="tw-px-0")
      v-row(no-gutters align="start")
        v-col
          v-row(no-gutters wrap align="center" )
            v-col(cols="auto" class="tw-mr-1 tw-ml-0 tw-pl-0")
                template(v-if="item.status == 'new'")
                  v-icon(x-small  color="blue lighten-1") mdi-circle
                template(v-if="item.status == 'converted'")
                  v-icon(x-small  color="green lighten-2") mdi-circle
                template(v-if="item.status == 'discarded'")
                  v-icon(x-small  color="orange lighten-1") mdi-circle
            v-col(cols="")
                span( :class="{read: isRead}" class="leadTitle" ) {{ item.name }} {{ item.last_name }}
            v-col(cols="auto" class=" tw-text-right")
                span( :class="{read: isRead}" class=" tw-text-indigo-lighten-3 tw-font-bold tw-text-sm" ) {{ formatDate(item.created_at) }}
          v-row( no-gutters wrap )
            v-col
              v-flex( class="tw-truncate tw-pt-1" xs12 )
                span( :class="{read: isRead}" class="leadSubject" ) {{ leadSubject }}
          v-row( no-gutters wrap )
            v-col(class="tw-overflow-hidden ")
              v-flex( xs12 )
                span( class="leadMessage tw-leading-snug " ) {{ this._.truncate(item.message, {'length': 100}) }}
</template>
<script>
    export default {
        props: {
            item: {
              type: Object,
              default: null
            },
            isRead: {
                type: Boolean,
                default: false,
            },
            isActive: {
                type: Boolean,
                default: false,
            },
            leadId: {
                type: Number,
                default: null,
            },
            leadTitle: {
                type: String,
                default: null,
            },
            leadDate: {
                type: String,
                default: null,
            },
            leadSubject: {
                type: String,
                default: null,
            },
            leadMessage: {
                type: String,
                default: null,
            },
            isFake: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
            };
        },
        created: function() {
            if (this.isFake) {
                this.isRead = this.$faker().random.boolean();
                this.leadTitle = this.$faker().name.findName();
                this.leadDate = this.$moment(this.$faker().date.recent(10)).fromNow();
                this.leadSubject = this.$faker().lorem.sentence();
                this.leadMessage = this.$faker().lorem.lines(1);
            }
        },
        methods: {
            click() {
                this.$emit('clicked', this.leadId);
            },
            formatDate(date){
              return this.$moment(date).fromNow()
            }
        },
    };
</script>
<style scoped>

  .title-unread {
    @apply tw-font-bold;
  }
  .leadContainer {
    cursor: hand;
    cursor: pointer;
    opacity: .9;
  }
  .leadContainer.read{
    @apply tw-bg-gray-lighten-4;
  }
  .leadContainer.active {
    @apply tw-bg-indigo-lighten-5;
  }
  .leadContainer.active .leadTitle{
    @apply tw-text-indigo-accent-2;
    @apply tw-font-bold;
  }
  .leadContainer.active .leadMessage{
    @apply tw-text-gray-darken-3;
  }

  .leadTitle {
    @apply tw-font-bold;
    @apply tw-text-gray-darken-3
  }
  .leadSubject {
    @apply tw-font-medium;
    @apply tw-text-blueGray-darken-3
  }
  .leadTitle.read {
    @apply tw-font-normal;
  }
  .leadTitle.subject{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .leadMessage {
    @apply tw-text-gray-darken-3
  }
 

</style>
